import { createApp } from "vue"
import CartPreviewDialog from "./cartPreviewDialog.vue"
import { getCookie } from "@/utils/cookie.js"
import GlobalConfig from "@/config/config.js";

export default function ShowCartPreviewDialog(options) {
  // 创建一个节点，并将组件挂载上去
  const mountNode = document.createElement("div")
  document.body.appendChild(mountNode)
  const app = createApp(CartPreviewDialog, {
    ...options,
    visible: true,
    remove() {
      app.unmount(mountNode) //创建完后要进行销毁
      document.body.removeChild(mountNode)
    },
  })
  app.config.globalProperties = {
    ...(window?.$getVueCurrentInstance()?.appContext?.config?.globalProperties ?? {}),
    ...app.config.globalProperties,
  }
  return app.mount(mountNode)
}